import { newDeleteFunction, newPostFunction, newPutFunction } from '@src/service/lib'
import { Uuid } from '@shared/helpers'
import { EditWalletAddressRequest, NewWalletAddressRequest } from './request'
import { walletUrl, editWalletUrl, entityWalletUrl, WalletUrlProps, EntityUrlProps } from './urls'

export const newWalletAddress = newPostFunction<{}, NewWalletAddressRequest, {}>(walletUrl)
export const editWalletAddress = newPutFunction<WalletUrlProps, EditWalletAddressRequest, {}>(editWalletUrl)
export const deleteWalletAddress = newDeleteFunction<EntityUrlProps & { address: Uuid }, {}>(entityWalletUrl)
